import type * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type GetRoleNameAndDescriptionQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.RoleFilterInput>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  order?: Types.InputMaybe<Array<Types.RoleSortInput> | Types.RoleSortInput>;
}>;


export type GetRoleNameAndDescriptionQuery = { roles?: Maybe<{ __typename?: 'RoleCollectionSegment', totalCount: number, items?: Maybe<Array<{ __typename?: 'Role', id: string, name: string, description?: Maybe<string> }>> }> };


export const GetRoleNameAndDescriptionDocument = gql`
    query getRoleNameAndDescription($where: RoleFilterInput, $take: Int, $skip: Int, $order: [RoleSortInput!]) {
  roles(where: $where, take: $take, skip: $skip, order: $order) {
    totalCount
    items {
      id
      name
      description
    }
  }
}
    `;

/**
 * __useGetRoleNameAndDescriptionQuery__
 *
 * To run a query within a React component, call `useGetRoleNameAndDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleNameAndDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleNameAndDescriptionQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetRoleNameAndDescriptionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRoleNameAndDescriptionQuery, GetRoleNameAndDescriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRoleNameAndDescriptionQuery, GetRoleNameAndDescriptionQueryVariables>(GetRoleNameAndDescriptionDocument, options);
      }
export function useGetRoleNameAndDescriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRoleNameAndDescriptionQuery, GetRoleNameAndDescriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRoleNameAndDescriptionQuery, GetRoleNameAndDescriptionQueryVariables>(GetRoleNameAndDescriptionDocument, options);
        }
export type GetRoleNameAndDescriptionQueryHookResult = ReturnType<typeof useGetRoleNameAndDescriptionQuery>;
export type GetRoleNameAndDescriptionLazyQueryHookResult = ReturnType<typeof useGetRoleNameAndDescriptionLazyQuery>;
export type GetRoleNameAndDescriptionQueryResult = Apollo.QueryResult<GetRoleNameAndDescriptionQuery, GetRoleNameAndDescriptionQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
export type Maybe<T> = Types.Maybe<T>;
